<template>
  <el-card class="seedling">
    <el-form class="global-form2" :model="info" ref="info" :rules="rules" label-width="90px">
      <el-form-item label="所属项目" prop="projectId">
        <el-select @change="selectProject" v-model="info.projectId" filterable placeholder="请选择所属项目">
          <el-option
            v-for="item in projectList"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="苗木名称" prop="plantName">
        <el-input v-model="info.plantName" placeholder="请输入苗木名称" maxlength="10" show-word-limit shclearable></el-input>
      </el-form-item>
      <el-form-item label="苗木类别" prop="seedlingType">
        <el-select v-model="info.seedlingType" filterable placeholder="请选择苗木类别">
          <el-option
            v-for="item in typeList"
            :key="item.dicCode"
            :label="item.dicValue"
            :value="item.dicCode"
          ></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="分区名称" prop="projectAreaId">-->
<!--        <el-select v-model="info.projectAreaId" filterable placeholder="请选择分区名称">-->
<!--          <el-option-->
<!--            v-for="item in areaList"-->
<!--            :key="item.projectAreaId"-->
<!--            :label="item.areaName"-->
<!--            :value="item.projectAreaId"-->
<!--          ></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="栽种日期" prop="plantDate">
        <el-date-picker
          v-model="info.plantDate"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择栽种日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="规格" prop="standard">
        <el-input v-model="info.standard" placeholder="请输入规格" maxlength="50" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="树龄" prop="treeAge">
        <el-input v-model="info.treeAge" placeholder="请输入树龄" maxlength="10" show-word-limit clearable></el-input>
      </el-form-item>

      <el-form-item label="苗木图片" prop="fileList" >
        <template slot="label">
          <span>
            图片
            <br/>(最多六张)
          </span>
        </template>
          <div class="imgList">
            <template v-if="info.fileList.length > 0">
              <div class="imgBlock" v-for="(itemImg, imgIndex) in info.fileList" :key="imgIndex">
                <el-image :src="itemImg.filePrefix + itemImg.fileUrl"
                  :preview-src-list="info.fileList | imgListFormat"
                  fit="fill">
                </el-image>
                <i class="el-icon-close" @click="imgRemove(index)"></i>
              </div>
            </template>
            <UploadFile v-if="info.fileList.length < 6" @onSuccess="onSuccess" :slotShow='true'>
              <template>
                <i class="el-icon-plus"></i>
                <p>上传图片</p>
              </template>
            </UploadFile>
          </div>
          <p class="imgTip">
            *建议图片尺寸: 750*750 750*1125<br>
            *支持JPG、JPEG、PNG格式,最少上传一张，最多可上传6张 <br>
            *每张图片大小不超过10M
          </p>
      </el-form-item>
      <el-tabs v-model="activeName" class = "ml20" type="card">
        <el-tab-pane label="苗木介绍" name="0">
          <el-form-item prop="seedlingIntroduce">
            <div id="seedlingIntroduce"></div>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="位置坐标及数量" name="1">
          <el-form-item prop="locationList" class="location-box">
            <template  v-if="activeName === '1'">
              <map-location
                :projectId="info.projectId"
                :projectAreaId ="info.projectAreaId"
                :locationList="locationList"
                :numberInput="true"
                :icon="require('@/assets/icon/seedling/icon_map_loc_tree_select.svg')"
                @locationChange="locationChange"
              ></map-location>
            </template>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <!-- <div v-for="(item,index) in [1,2]" :key="index">
          <img src="https://test.qn.saas.gintell.cn/2023118/65EBBA622A20A0D42ED9B1B04E705A29" alt="" srcset="">
      </div> -->
      <el-form-item class="ml20">
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
        <el-button @click="$router.push({name:'seedlingList'})">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import MapLocation from '@/components/mapLocation/Index.vue'
import { initWangEdit } from '@/utils/wangEdit'
import UploadFile from '@/components/uploadFile/Index.vue'
export default {
  name: 'SeedlingAdd',
  components: { MapLocation, UploadFile },
  filters: {
    imgListFormat (list) {
      const imgList = list.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }
  },
  data () {
    return {
      info: {
        projectId: '',
        seedlingType: '',
        plantName: '',
        projectAreaId: '',
        plantDate: '',
        treeAge: '',
        standard: '',
        isFamous: '0',
        locationList: [],
        seedlingIntroduce: '',
        fileList: []
      },
      rules: {
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        seedlingType: [
          { required: true, message: '请选择苗木类别', trigger: 'change' }
        ],
        plantName: [
          { required: true, message: '请输入苗木名称', trigger: 'change' }
        ],
        plantDate: [
          { required: true, message: '请选择栽种日期', trigger: 'change' }
        ],
        locationList: [
          { required: true, message: '请选择位置坐标及数量', trigger: 'change' }
        ],
        fileList: [
          { required: true, message: '请选择苗木图片', trigger: 'change' }
        ],
        seedlingIntroduce: [
          { required: true, message: '请输入苗木介绍', trigger: ['change', 'blur'] }
        ]
      },
      areaList: [],
      typeList: [],
      // 默认展示苗木介绍
      activeName: '0',
      seedlingIntroduce: null,
      locationList: null,
      submitShow: false
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    },
    seedlingId () {
      return this.$route.params.seedlingId
    }
  },
  created () {
    this.getTypeList()
    this.init()
    if (this.seedlingId) {
      this.getDetail()
    }
  },
  mounted () {
  },
  beforeDestroy () {
    // 销毁编辑器
    this.seedlingIntroduce.destroy()
    this.seedlingIntroduce = null
  },
  methods: {
    // 查询苗木类别列表
    getTypeList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'seedlingType' }).then(res => {
        this.typeList = res.seedlingType || []
      })
    },
    // 获取区域
    getAreaList (id) {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByList, {
        projectId: id
      }).then(res => {
        this.areaList = res || []
      })
    },
    selectProject (value) {
      // this.info.projectAreaId = ''
      // this.getAreaList(value) // 获取分区列表
    },
    imgRemove (index) {
      this.info.fileList.splice(index, 1)
    },
    // 文件上传成功返回
    onSuccess (file) {
      this.info.fileList.push(file)
      this.$nextTick(() => {
        this.$refs.info.clearValidate()
      })
    },
    // 富文本初始化
    init () {
      this.$nextTick(() => {
        this.seedlingIntroduce = initWangEdit('#seedlingIntroduce', { placeholder: '请输入植物介绍' })
        this.seedlingIntroduce.create()
        // 动态监听富文本改变
        this.seedlingIntroduce.config.onchange = (html) => {
          this.info.seedlingIntroduce = this.seedlingIntroduce.txt.html()
          if (html) {
            this.$refs.info.clearValidate()
          }
        }
      })
    },
    // 编辑
    getDetail () {
      this.$axios.get(this.$apis.seedling.selectYhSeedlingBySeedlingId, {
        seedlingId: this.seedlingId
      }).then(res => {
        if (res) {
          // console.log('res', res)
          this.info = res
          this.seedlingIntroduce.txt.html(this.info.seedlingIntroduce || '')
          this.locationList = res.locationList || []
          this.getAreaList(res.projectId) // 获取分区列表
        }
      })
    },
    locationChange (list) {
      // console.log('locationChange', list)
      this.info.locationList = list
    },
    onSubmit () {
      this.$refs.info.validate(valid => {
        if (valid) {
          this.submitShow = true
          const url = this.seedlingId ? this.$apis.seedling.updateYhSeedling : this.$apis.seedling.insertYhSeedling
          this.$axios.post(url, this.info).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";
.global-form2{
  .ml20 {
    margin-left: 20px !important;
    ::v-deep {
      .el-form-item__content{
        margin-left: 0px !important;
      }
    }
  }

  .imgList{
    display: flex;
    flex-wrap: wrap;

    .imgBlock {
      position: relative;
      height: 104px;
      width: 104px;
      margin:0 10px 10px 0;
      .el-image,img{
        width:100%;
        height: 100%;
      }

      span {
        position: absolute;
        top: 0;
        right: 0;
        width: 0px;
        height: 0px;
        border-top: 34px solid $color-default;
        border-left: 34px solid transparent;
      }

      i {
        transition: all 0.3s;
        position: absolute;
        top: 3px;
        right: 3px;
        font-size: 15px;
        color: #ffffff;
        cursor: pointer;
      }
      i:hover {
        color: #ffffff98;
      }
    }
    ::v-deep .el-upload--picture-card{
      width: 104px;
      height: 104px;
      line-height: 26px;
      padding:25px 10px;
    }
  }

  ::v-deep {
    .el-tabs__item:not(.is-active){
      background: #F4F7FA;
      border-bottom: 1px solid #E4E7ED;
    }

    .el-tabs__content {
      padding: 10px 20px;
    }
  }

  .location-box {
    display: flex;
    flex-direction: column;
    .mapContent{
      max-width: 100% !important;
    }
  }

  ::v-deep .w-e-text-container {
    height: 384px !important;
  }

  .el-tabs {
    ::v-deep .el-tabs__item::before{
      content: "*";
      color: #F56C6C;
      margin-right: 4px;
    }
  }
}
</style>
